import Splide from "../../../node_modules/@splidejs/splide";


export function initBlockSliderdefault() {
    [...document.querySelectorAll(".splide.slider-default:not(.-initialized)")].map((el) => new ComponentSplideSliderdefault(el));
}

export class ComponentSplideSliderdefault {

    _dom = {
        slider: null,
    };

    _splide = null

    constructor(el) {
        if (!el) return;

        this._dom.slider = el;

        this._splide = new Splide(el, {
            type: 'slider',
            perPage: '1',
            gap: '2rem',
            pagination: false,
            arrowPath: 'M30.07 22.59L16.33 36.33L20 40L40 20L20 0L16.33 3.67L30.07 17.41L0 17.41L0 22.59L30.07 22.59z',
            breakpoints: {
                // 1023: {
                //     arrows: false,
                // },
            },
            classes: {
                arrows: 'splide__arrows demo',
                arrow : 'splide__arrow demo',
                prev  : 'splide__arrow--prev  demo demo-arrow_left-1',
                next  : 'splide__arrow--next demo demo-arrow_left-1',
            },

        }).mount()

    }
}